<template>
  <div style="padding-bottom: 70px">
    <div v-for="(item,index) in troubleList" :key="item.nanoid" class="trouble-item">
      <div class="title">
        <span>{{ '定损故障' + (index + 1) }}</span>
        <el-button type="primary" link @click="troubleList.splice(index,1)" style="margin-left: 20px">删除故障</el-button>
      </div>
      <FrameForm :ref="'item_'+item.nanoid" component-param="station_identify_trouble"
                 :parentData="{item_id: parentData.id}"/>
    </div>
    <el-row class="btn-row">
      <el-button link type="primary" @click="addTrouble">增加新故障</el-button>
    </el-row>
    <el-row class="btn-row submit-row">
      <el-button @click="submit" :loading="loading">提交定损结果</el-button>
      <KfMessage ref="submitMsg"></KfMessage>
    </el-row>
  </div>
</template>

<script>
import {nanoid} from "nanoid";
import {ElMessage, ElMessageBox} from "element-plus";

export default {
  name: "StationIdentify",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      troubleList: []
    }
  },
  mounted() {
    this.addTrouble()
  },
  methods: {
    async addTrouble() {
      this.troubleList.push({
        nanoid: nanoid(),
      })
    },
    clearMessage() {
      this.$refs.submitMsg.clear()
    },
    reset() {
      this.troubleList.forEach(item => {
        this.$refs['item_' + item.nanoid][0].formInfo = {}
      })
      this.troubleList = []
      this.addTrouble()
    },
    initForm() {

    },

    submit() {
      ElMessageBox.confirm(
          '确定提交当前工站作业结果吗？',
          '提示',
          {
            confirmButtonText: '确认',
            type: 'warning',
          }
      ).then(() => {
            this.submitResult()
          })
    },

    submitResult() {
      this.$refs.submitMsg.clear()
      if (!this.parentData.id) {
        this.$refs.submitMsg.showError('请先扫描SN进行查询');
        return;
      }

      let arr = []
      for (let i = 0; i < this.troubleList.length; i++) {
        let item = this.troubleList[i]
        let formData = this.$refs['item_' + item.nanoid][0].formInfo
        if (!formData.trouble_type) {
          return this.$refs.submitMsg.showError('第' + (i + 1) + '个故障，请选择故障类型');
        }
        if (!formData.material_list || formData.material_list.length === 0) {
          return this.$refs.submitMsg.showError('第' + (i + 1) + '个故障，请添加所需物料');
        }
        formData.trouble_id = item.nanoid
        arr.push(formData)
      }

      if (this.troubleList.length === 0) {
        return this.$refs.submitMsg.showError('请添加至少一个故障');
      }

      this.loading = true;
      this.$http('buItemService.submitIdentifyResult', {
        id: this.parentData.id,
        trouble_list: arr
      }, false).then(data => {
        this.loading = false;
        this.$refs.submitMsg.showSuccess(data);
        this.reset()
        this.$fn.reset()
      }, errMsg => {
        this.loading = false;
        this.$refs.submitMsg.showError(errMsg);
      })
    }
  }
}
</script>

<style scoped lang="less">

.trouble-form{
  padding: 10px 0 0 0;
  width: 700px;
}

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;

  .title {
    background-color: #ddd;
    padding: 5px 0 5px 10px;
    font-weight: bold;
  }
}

.btn-row {
  padding: 5px 0;
}

.submit-row {
  margin: 30px 0;
  padding-top: 20px;
  padding-left: 130px;
  border-top: 1px solid #ddd;
}
</style>